// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert_alert__1VKju","mobile":"alert_mobile__3OxE7"};